<div class="main-page-section default_font">
  <section class="px-3 px-md-4 px-lg-5 pl-xl-6 overview_section">
    <div class="row row-gap-3 align-items-end pt-4 pt-md-5">
      <div class="col-12 col-md-6 pt-4 pt-md-5 pb-8 pb-md-10">
        <h1 class="font-weight-medium text-primary-medium mb-4 mb-md-5">
          <span class="text-gray-dark d-block h4 mb-2">Start building</span>
          <span class="text-black h4">your</span> organisation
        </h1>
        <p class="">Manage your employess, invite guests to the park, events & much more..</p>
      </div>
      <div class="col-12 col-md-6 text-right">
        <img src="/assets/images/dashboard_graphic.jpg" class="overview_image img-fluid" />
      </div>
    </div>
  </section>
  <section class="px-3 px-md-4 px-lg-5 pl-xl-6 py-3 py-md-4">
    <h2 class="h4 font-weight-bold text-gray-dark mb-3 mb-md-4">Organisation Overview</h2>
    <div class="_content_container">
      <div class="row row-gap-4">
        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" routerLink="/company">
            <h3 class="h6 font-weight-semibold mb-0">Companies<br>enrolled</h3>
            <span class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.companiedEnrolled}}</span>
            <img class="_card_icon" src="../../assets/images/companies-enrolled-overview.png" />
            <img class="_card_icon _hover" src="../../assets/images/companies-enrolled-overview-hover.png" />
          </div>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
          <div class="overview_card p-3 py-md-4" (click)="routeToReports()">
            <div class="row row-gap-2">
              <div class="col-12 col-md-2 align-self-center">
                <h3 class="h6 font-weight-semibold mb-0">Employees<br>enrolled</h3>
              </div>
              <div class="col-12 col-md-1">
                <span class="_card_separator"></span>
              </div>
              <div class="col-12 col-md-9">
                <div class="form-row position-relative z-index-2">
                  <div class="col-12 col-md-4 d-flex flex-column">
                    <h4 class="h6 font-weight-semibold mb-0 flex-fill">Verified</h4>
                    <span class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.verified}}</span>
                    <!-- <h4 class="h6 font-weight-semibold mb-0 flex-fill">Verified with <br>invite access</h4> -->
                    <!-- <span class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.verifiedWihVMSAccess}}</span> -->
                  </div>
                  <!-- <div class="col-12 col-md-4 d-flex flex-column">
                    <h4 class="h6 font-weight-semibold mb-0 flex-fill">Verified without <br>invite access</h4>
                    <span
                      class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.verifiedWithOutVMSAccess}}</span>
                  </div> -->
                  <div class="col-12 col-md-4 d-flex flex-column">
                    <h4 class="h6 font-weight-semibold mb-0 flex-fill">Non-verified</h4>
                    <span class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.nonVerified}}</span>
                  </div>
                </div>
              </div>
            </div>
            <img class="_card_icon" src="../../assets/images/overview-employees-enrolled.png" />
            <img class="_card_icon _hover" src="../../assets/images/overview-employees-enrolled-hover.png" />
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" routerLink="/bulk-invite-approval">
            <h3 class="h6 font-weight-semibold mb-0">Bulk Invite Requests pending</h3>
            <span
              class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.vmsBulInvitePendingRequest}}</span>
            <img class="_card_icon" src="../../assets/images/overview-day-pass-today.png" />
            <img class="_card_icon _hover" src="../../assets/images/overview-day-pass-hover.png" />
          </div>
        </div>
        <!-- <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" (click)="redirectToAccess()" routerLink="/parkite-overview">
            <h3 class="h6 font-weight-semibold mb-0">Access Rights approval pending</h3>
            <span
              class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.accessRightsApprovalPending}}</span>
            <img class="_card_icon" src="../../assets/images/overview-day-pass-today.png" />
            <img class="_card_icon _hover" src="../../assets/images/overview-day-pass-hover.png" />
          </div>
        </div> -->
        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" routerLink="/events">
            <h3 class="h6 font-weight-semibold mb-0">Events Pass approval pending</h3>
            <span class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.eventPassApprovalPending}}</span>
            <img class="_card_icon" src="../../assets/images/overview-meeting-rooms.png" />
            <img class="_card_icon _hover" src="../../assets/images/overview-meetings-hover.png" />
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" routerLink="/events">
            <h3 class="h6 font-weight-semibold mb-0">Events Participate approval pending</h3>
            <span class="d-block mt-3 mb-0 h2 font-weight-medium text-primary">{{data?.eventsParticipateApprovalPending}}</span>
            <img class="_card_icon" src="../../assets/images/overview-meeting-rooms.png" />
            <img class="_card_icon _hover" src="../../assets/images/overview-meetings-hover.png" />
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" (click)="routeToMeetingReport()">
            <h3 class="h6 font-weight-semibold mb-0">Visitor Data</h3>
            <span class="d-block small text-gray-medium mt-1">(Today)</span>
            <div class="form-row position-relative z-index-2 text-center">
              <div class="col-12 col-md-6 d-flex flex-column">
                <h4 class="d-block mt-3 mb-0 h2 font-weight-medium text-primary flex-fill">
                  {{data?.overViewModelVisitorData?.expected}}</h4>
                <span class="small font-weight-normal text-gray-medium mt-2 mb-0">Expected</span>
              </div>
              <div class="col-12 col-md-6 d-flex flex-column">
                <h4 class="d-block mt-3 mb-0 h2 font-weight-medium text-primary flex-fill">
                  {{data?.overViewModelVisitorData?.checkedIn}}</h4>
                <span class="small font-weight-normal text-gray-medium mt-2 mb-0">Checked In</span>
              </div>
            </div>
            <img class="_card_icon" src="../../assets/images/overview-parking.png" />
            <img class="_card_icon _hover" src="../../assets/images/overview-parking-hover.png" />
          </div>
        </div>

        <!-- users modal start -->
        <!-- <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" (click)="usersModal(usersContent)">
            <h3 class="h6 font-weight-semibold mb-0">Users</h3>
            <img class="_card_icon" src="/assets/images/users_icon.png" />
            <img class="_card_icon _hover" src="/assets/images/users_icon_hover.png" />
          </div>
          <ng-template #usersContent let-modal>
            <div class="modal-header px-7 pt-5">
              <h4 class="font-weight-normal text-gray-dark mb-0">Users</h4>
              <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
                <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
              </button>
            </div>
            <div class="modal-body">
              <div class="border-top border-gray-medium pt-4 text-gray-dark">
                <div *ngFor="let menu of usersMenus; let last = last" [ngClass]="!last && 'mb-4 mb-md-5'">
                  <h5 class="h6 font-weight-semibold mb-3">{{menu.title}}</h5>
                  <div class="row">
                    <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let menuItem of menu.categories">
                      <div class="menu_item p-2 p-md-3 h-100" (click)="goToPage(menuItem.link)">
                        <svg-icon [src]="menuItem.icon"></svg-icon>
                        <span class="small">{{menuItem.title}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div> -->
        <!-- users modal end -->

        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" (click)="manageServices(manageServiceContent)">
            <h3 class="h6 font-weight-semibold mb-0">Manage Services</h3>
            <img class="_card_icon" src="../../assets/images/manage_service_icon.png" />
            <img class="_card_icon _hover" src="../../assets/images/manage_service_icon_hover.png" />
          </div>

          <!-- manage service modal start -->
          <ng-template #manageServiceContent let-modal>
            <div class="modal-header px-7 pt-5">
              <h4 class="font-weight-normal text-gray-dark mb-0">Manage Services</h4>
              <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
                <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
              </button>
            </div>
            <div class="modal-body">
              <div class="border-top border-gray-medium pt-4 text-gray-dark">
                <div *ngFor="let menu of manageServiceMenus; let last = last" [ngClass]="!last && 'mb-4 mb-md-5'">
                  <h5 class="h6 font-weight-semibold mb-3">{{menu.title}}</h5>
                  <div class="row">
                    <div class="col-12 col-md-6" *ngFor="let menuItem of menu.sub">
                      <div class="menu_item p-2 p-md-3 h-100" (click)="goToPage(menuItem.link)">
                        <svg-icon [src]="menuItem.icon"></svg-icon>
                        <span class="small">{{menuItem.title}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <!-- manage service modal end -->
        </div>

        <!-- survey pools modal start -->
        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" (click)="surveyModal(surveyContent)">
            <h3 class="h6 font-weight-semibold mb-0">Surveys and Polls</h3>
            <div class="form-row position-relative z-index-2 text-center">
              <div class="col-12 col-md-6 col-lg-5 d-flex flex-column">
                <h4 class="d-block mt-3 mb-0 h2 font-weight-medium text-primary flex-fill">
                  {{dataSurvey?.totalSurveyCount}}</h4>
                <span class="small font-weight-normal text-gray-medium mt-2 mb-0">Total Created</span>
              </div>
              <div class="col-12 col-md-6 col-lg-7 d-flex flex-column">
                <h4 class="d-block mt-3 mb-0 h2 font-weight-medium text-primary flex-fill">
                  {{dataSurvey?.surveyResponseCount}}</h4>
                <span class="small font-weight-normal text-gray-medium mt-2 mb-0">Response Received</span>
              </div>
            </div>
            <img class="_card_icon" src="/assets/images/survey_polls.png" />
            <img class="_card_icon _hover" src="/assets/images/survey_polls_hover.png" />
          </div>
          <ng-template #surveyContent let-modal>
            <div class="modal-header px-7 pt-5">
              <h4 class="font-weight-normal text-gray-dark mb-0">Surveys and Polls</h4>
              <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
                <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
              </button>
            </div>
            <div class="modal-body">
              <div class="border-top border-gray-medium pt-4 text-gray-dark">
                <div *ngFor="let menu of surveyMenus; let last = last" [ngClass]="!last && 'mb-4 mb-md-5'">
                  <h5 class="h6 font-weight-semibold mb-3">{{menu.title}}</h5>
                  <div class="row">
                    <div class="col-12 col-md-6" *ngFor="let menuItem of menu.sub">
                      <div class="menu_item p-2 p-md-3 h-100" (click)="goToPage(menuItem.link)">
                        <svg-icon [src]="menuItem.icon"></svg-icon>
                        <span class="small">{{menuItem.title}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <!-- survey pools modal end -->

        <!-- food court modal start -->
        <div class="col-12 col-md-4 col-lg-3">
          <div class="overview_card p-3 py-md-4" (click)="foodCourtModal(foodCourtContent)">
            <h3 class="h6 font-weight-semibold mb-0 position-relative z-index-1">Food Court Management</h3>
            <img class="_card_icon" src="/assets/images/food_court_card.png" />
            <img class="_card_icon _hover" src="/assets/images/food_court_card_hover.png" />
          </div>
          <ng-template #foodCourtContent let-modal>
            <div class="modal-header px-7 pt-5">
              <h4 class="font-weight-normal text-gray-dark mb-0">Food Court Management</h4>
              <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
                <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
              </button>
            </div>
            <div class="modal-body">
              <div class="border-top border-gray-medium pt-4 text-gray-dark">
                <div *ngFor="let menu of foodCourtMenus; let last = last" [ngClass]="!last && 'mb-4 mb-md-5'">
                  <div class="row row-gap-4">
                    <div class="col-12 col-md-6" *ngFor="let menuItem of menu.sub">
                      <div class="menu_item p-2 p-md-3 h-100" (click)="goToPage(menuItem.link)">
                        <svg-icon [src]="menuItem.icon"></svg-icon>
                        <span class="small">{{menuItem.title}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <!-- food court modal end -->
      </div>
    </div>
  </section>
</div>